<script setup lang="ts">
import AuthScreenLayout from '@/layout/AuthScreenLayout.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';

function reload() {
  window.location.reload();
}
</script>

<template>
  <AuthScreenLayout>
    <div class="flex flex-col items-center" data-test="screen-error">
      <ExclamationTriangleIcon class="mb-3 size-10 text-gray-400" aria-hidden="true" />
      <h1 class="mb-4 text-3xl font-bold text-gray-900">Something went wrong</h1>
      <p class="mb-8 text-gray-500">
        Try reloading the page. If the issue persists, please contact engineering.
      </p>
      <BaseButton text="Reload" @click="reload" />
    </div>
  </AuthScreenLayout>
</template>
